module.exports = __webpack_public_path__ + "img/photo_2023-11-27 11.39.47.5a7c1437.jpg";